<template>
  <div class="teacher-user-menu">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="290"
      transition="slide-y-transition"
      offset-y
      left
      content-class="teacher-user-menu__popover"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          large
          aria-label="Open account menu"
          :aria-expanded="menu ? 'true' : 'false'"
        >
          <v-avatar size="36">
            <v-img v-if="currentUser.imageUrl" :src="currentUser.imageUrl" :alt="currentUser.name" />
            <img v-else src="@/assets/images/user.jpeg" :alt="currentUser.name" />
          </v-avatar>
        </v-btn>
      </template>

      <v-card class="teacher-account-card" elevation="0">
        <div class="teacher-account-card__profile">
          <v-avatar size="52" class="teacher-account-card__avatar">
            <v-img v-if="currentUser.imageUrl" :src="currentUser.imageUrl" :alt="currentUser.name" />
            <img v-else src="@/assets/images/user.jpeg" :alt="currentUser.name" />
          </v-avatar>
          <div class="teacher-account-card__identity">
            <strong>{{ currentUser.name }}</strong>
            <span>{{ currentUser.email }}</span>
            <small>{{ userRole }}</small>
          </div>
          <v-btn icon small aria-label="Close account menu" @click="menu = false">
            <v-icon size="19">mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="teacher-account-card__meta">
          <div>
            <span class="teacher-account-card__meta-icon"><v-icon size="18" color="#2f7d4a">mdi-map-marker-outline</v-icon></span>
            <span><small>Location code</small><strong>{{ currentBusiness.code }}</strong></span>
          </div>
          <div>
            <span class="teacher-account-card__meta-icon"><v-icon size="18" color="#3c6e9c">mdi-information-outline</v-icon></span>
            <span><small>App version</small><strong>{{ version }}</strong></span>
          </div>
        </div>

        <div class="teacher-account-card__actions">
          <button type="button" @click="reload">
            <span><v-icon size="20" color="#2f7d4a">mdi-refresh</v-icon></span>
            <span><strong>Reload application</strong><small>Refresh your latest information</small></span>
            <v-icon size="18" color="#96a29a">mdi-chevron-right</v-icon>
          </button>
        </div>

        <div class="teacher-account-card__footer">
          <span>Signed in securely</span>
          <v-btn text color="primary" to="/logout" @click="menu = false">
            <v-icon left size="18">mdi-logout-variant</v-icon>
            {{ $t("buttons.logout") }}
          </v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const pjson = require("../../../../package.json");

export default {
  name: "layout-menu",
  data() {
    return { menu: false };
  },
  computed: {
    ...mapGetters("global", ["currentUser", "currentBusiness"]),
    version() {
      return pjson.version;
    },
    userRole() {
      if (this.currentUser.superAdmin) return "Super admin";
      if (this.currentUser.isAdmin) return "Administrator";
      return "Teacher";
    },
  },
  methods: {
    reload() {
      this.menu = false;
      this.$router.go();
    },
  },
};
</script>
